var map = {
	"./360.jpg": "cb02",
	"./ailpay.jpg": "d677",
	"./alibaba.jpg": "148d",
	"./anker.jpg": "90b2",
	"./baidu.jpg": "a5de",
	"./byte.jpg": "9a5b",
	"./car.jpg": "4899",
	"./cctv.jpg": "3bd3",
	"./changyou.jpg": "e5ed",
	"./ctrip.jpg": "7cf6",
	"./dji.jpg": "2e9e",
	"./dr.jpg": "ce733",
	"./ebay.jpg": "2e5e",
	"./funplus.jpg": "0401",
	"./huawei.jpg": "2a27",
	"./huaxizi.jpg": "c532",
	"./jd.jpg": "63a9",
	"./jovs.jpg": "7c35",
	"./lenovo.jpg": "a100",
	"./meitu.jpg": "f14d",
	"./mi.jpg": "3970",
	"./midea.jpg": "f4dd",
	"./perfect.jpg": "2c34",
	"./pop mart.jpg": "1430",
	"./shein.jpg": "ec8e",
	"./tencent.jpg": "3b4e",
	"./wangyigame.jpg": "48e2",
	"./worx.jpg": "e9bb",
	"./yoozoo.jpg": "aafb",
	"./zulong.jpg": "ac1e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f097";